export type CityStatus = 'live' | 'planned'

export interface City {
  name: string
  state: string
  status: CityStatus
  /** Year the office opened, or the year we intend to open it. */
  year: number
  lead: string
  blurb: string
}

const SEARCHING = 'Adviser search underway'

export const cities: City[] = [
  {
    name: 'Bengaluru',
    state: 'Karnataka',
    status: 'live',
    year: 2026,
    lead: 'Prashanth Sekhar, Founder',
    blurb:
      'Where MeraBucket was founded, and the home of the research desk. Serves founders, senior operators and professional families holding concentrated equity.',
  },
  {
    name: 'Chennai',
    state: 'Tamil Nadu',
    status: 'live',
    year: 2026,
    lead: 'Founding team, with Prashanth Sekhar',
    blurb:
      'Our first branch, opened later in 2026. Prashanth meets families here himself, across Chennai and the wider Tamil Nadu belt.',
  },
  {
    name: 'Pondicherry',
    state: 'Puducherry',
    status: 'planned',
    year: 2027,
    lead: SEARCHING,
    blurb: 'Hospitality, trading and retired professional families along the coast.',
  },
  {
    name: 'Mangaluru',
    state: 'Karnataka',
    status: 'planned',
    year: 2027,
    lead: SEARCHING,
    blurb: 'Banking, healthcare and export families, many with members working abroad.',
  },
  {
    name: 'Madurai',
    state: 'Tamil Nadu',
    status: 'planned',
    year: 2027,
    lead: SEARCHING,
    blurb: 'Trading, textile and land-holding families across southern Tamil Nadu.',
  },
  {
    name: 'Pune',
    state: 'Maharashtra',
    status: 'planned',
    year: 2027,
    lead: SEARCHING,
    blurb: 'Engineering and auto-component promoter families, plus first-generation technology wealth.',
  },
  {
    name: 'Belgaum',
    state: 'Karnataka',
    status: 'planned',
    year: 2028,
    lead: SEARCHING,
    blurb: 'Foundry, agri-processing and education-trust families in the border belt.',
  },
  {
    name: 'Nashik',
    state: 'Maharashtra',
    status: 'planned',
    year: 2028,
    lead: SEARCHING,
    blurb: 'Agri-processing, pharma and winery families across the Nashik–Dindori belt.',
  },
  {
    name: 'Indore',
    state: 'Madhya Pradesh',
    status: 'planned',
    year: 2028,
    lead: SEARCHING,
    blurb: 'Second-generation traders and manufacturers preparing for succession.',
  },
]

export const liveCities = cities.filter((city) => city.status === 'live')
export const plannedCities = cities.filter((city) => city.status === 'planned')
